import SelectComponent from "../../../ui/select/SelectComponent";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import * as React from "react";


export default class SelectDictionaryItem extends SelectComponent<DictionaryItem> {

	matchFilter(element: DictionaryItem, filter: string): boolean {
		return element.searchString.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: DictionaryItem): string {
		return element.id;
	}

	elementToString(element: DictionaryItem) {
		return element.name;
	}
}